(function ($)
{
	window.Tool = function () { };
	Tool.prototype.Init = function (oChart) {
		this._baseInit(oChart);
	};
	Tool.prototype._baseInit = function (oChart) {
		this._chart = oChart;
		this._container = this._chart.GetContainer();
		this._chart.Subscribe("OutputUpdate", this._handleOutputDataUpdate.Context(this));
		this._listeners = {};
	};
	Tool.prototype.Enable = function () {};
	Tool.prototype.Disable = function () {};
	Tool.prototype._getPanels = function () {
		return this._chart.GetPanels();
	};
	Tool.prototype._getPanelElements = function () {
		var rPanels = this._chart.GetPanels()
		var jElements = $();
		for (var i = 0; i < rPanels.length; i++) {
			jElements = jElements.add(rPanels[i].GetContainer());
		}
		return jElements;
	};
	//Custom Events
	Tool.prototype.Broadcast = function (sEvent, oData) {
		var rListeners = this._listeners[sEvent];
		if (rListeners) {
			for (var i = 0; i < rListeners.length; i++) {
				rListeners[i].call(this, oData);
			}
		}
	};
	Tool.prototype.Subscribe = function (sEvent, fListener) {
		this._listeners[sEvent] = this._listeners[sEvent] || [];
		this._listeners[sEvent].push(fListener);
	};
	//Event Handlers
	Tool.prototype._handleOutputDataUpdate = function (oEvent, oData) { };
	//Misc
	Tool.prototype._getOverlayTypeByUID = function (sUid, nPanel) {
		var oPanel = this._chart._panels[nPanel];

		var oInputData = oPanel.GetInputs();
		var rOverlays = oInputData.Overlays;
		var sType = null;
		if (rOverlays) {
			for (var i = 0; i < rOverlays.length; i++) {
				if (rOverlays[i].Uid == sUid) {
					sType = rOverlays[i].Type;
				}
			}
		} 
		return sType;
	};
	Tool.prototype._getPanelTypeByUid = function (sUid, nPanel) {
		var oPanel = this._chart._panels[nPanel];
		var sType = null;
		if (oPanel.GetUID() == sUid) {
			sType = this._convertPanelType(oPanel.GetType());
		}
		return sType;
	};
	Tool.prototype._convertPanelType = function (sType) {
		if (InteractiveChart.PRICE_PANEL_TYPES[sType]) {
			sType = "Price";
		}
		return sType;
	};

	//Mouse Tracking Tool (Abstract)
	window.MouseTrackingTool = function () { };
	MouseTrackingTool.prototype = new Tool();
	MouseTrackingTool.prototype.TOOL_ID;
	//Public
	MouseTrackingTool.prototype._startTracking = function () {
		var sEvent = "mousemove." + this.TOOL_ID;
		if (this._mouseMoveEvent) {
			this._mouseMoveEvent.unbind(sEvent);
		}
		this._mouseMoveEvent = $(this._getPanelElements()).bind(sEvent, this._baseHandleMouseMove.Context(this));
	};
	MouseTrackingTool.prototype._stopTracking = function () {
		var sEvent = "mousemove." + this.TOOL_ID;
		this._mouseMoveEvent.unbind(sEvent);
	};
	MouseTrackingTool.prototype._getDataForLatestXCoord = function (nPos, nPanel) {
		nPanel = nPanel || 0;
		var oPanel = this._chart._panels[nPanel];
		if (!oPanel) {
			return null;
		}
		return oPanel.GetNearestDataFromXCoord(nPos);
	};
	MouseTrackingTool.prototype._getLastDataPoint = function (nPanel) {
		var nLastPoint;
		var oPanel = this._chart._panels[nPanel];
		var oPoints = oPanel._outputData.Data.Points || {};
		for (var nPoint in oPoints) {
			nLastPoint = nPoint;
		}	
		return nLastPoint;
	};
	//Event Handlers
	MouseTrackingTool.prototype._baseHandleMouseMove = function (oEvent) {
		var oCoords = { x: oEvent.pageX, y: oEvent.pageY };
		this._handleMouseMove(oCoords);
		this.Broadcast("mousemove", oCoords);
	};
	MouseTrackingTool.prototype._handleMouseMove = function (oMouse) {};
})(jQuery);